import { render, staticRenderFns } from "./TeamTouchPerformance.vue?vue&type=template&id=0614cf9f"
import script from "./TeamTouchPerformance.vue?vue&type=script&lang=js"
export * from "./TeamTouchPerformance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports